import { render, staticRenderFns } from "./CodeRun.vue?vue&type=template&id=a4cbd3f8&scoped=true&"
var script = {}
import style0 from "./CodeRun.vue?vue&type=style&index=0&id=a4cbd3f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cbd3f8",
  null
  
)

export default component.exports